<script>
import DateMixin from "@/mixins/Date"
import Vue from "vue"
import { DEFAULT_DATE } from "@/utils/config"

export default {
  name: "LastTableMixin",
  props: {
    startDate: {
      type: String,
      required: false,
    },
  },
  mixins: [DateMixin],

  data: function () {
    return {
      loading: false,
    }
  },
  mounted() {
    this.refresh()
  },
  methods: {
    async refresh() {
      let _date
      if (this.startDate && this.startDate !== "unlimited") {
        let date = new Date()
        _date = Vue.moment(date)
          .subtract(this.startDate, "day")
          .format(DEFAULT_DATE)
      }

      this.loading = true
      await this.FETCH({
        limit: 5,
        ...(_date && {
          start_date: _date,
        }),
      }).finally(() => {
        this.loading = false
      })
      this.loading = false
    },
  },
  watch: {
    startDate() {
      this.refresh()
    },
  },
}
</script>
